import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Filters,
  Image,
  ChoiceList,
  Loading,
  Card,
  Text,
  Banner,
  Spinner,
  ButtonGroup,
  Button,
  Modal,
  Badge,
  Toast,
  TextContainer,
  Link,
  Icon,
  FormLayout,
  Tooltip,
  Select,
  Layout,
  Thumbnail,
  InlineGrid,
  Box,
  Pagination,
  Divider,
  Tag,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { default as MyPagination } from "@material-ui/lab/Pagination";
import { useParams, useNavigate } from "react-router-dom";
import {
  ArrowUpIcon,
  ArrowDownIcon,
  LinkIcon,
  EditIcon,
} from "@shopify/polaris-icons";
import EllipsisText from "react-ellipsis-text";

const Tasks = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const refBoolPage = useRef(true);
  const refId = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const perPage = 50;
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [sortState, setSortState] = useState("-id");
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleSort = () =>
    sortState === "id" ? setSortState("-id") : setSortState("id");
  const handleEdit = (param) => {
    navigate(`/admin/goals/${id}/tasks/${param}`);
  };
  const handleScreenshots = (id) => {
    // console.log("url=", `/admin/tasks/${id}/screenshots`);
    navigate(`/admin/tasks/${id}/screenshots`);
  };
  const handleAddItem = () => {
    navigate(`/admin/goals/${id}/tasks/new`);
  };

  const [ts, setTs] = useState("");
  const handleUp = (param) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/goals/${id}/tasks/${param}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (param) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/goals/${id}/tasks/${param}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const [optionsCategories, setOptionsCategories] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [result, setResult] = useState(null);
  useEffect(() => {
    fetchData();
  }, [page, sortState, availability, queryValue, ts]);

  const handleRowClick = (param) => {
    setCurrentIndex(param);
    console.log(result?.[param]);
    setActiveShow(true);
  };
  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `/goals/${id}/tasks?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${queryValue ? `&filter[title]=${queryValue}` : ""}`
      );
      !response.data.data.length ? setIsListEmpty(true) : setIsListEmpty(false);
      console.log(response?.data?.data);
      // setTotalPages(response.data.data.total);
      setItems(
        response.data.data.map((item, index) => [
          item?.title ?? "",
          <ButtonGroup>
            <Button
              onClick={() => handleUp(item.id)}
              icon={ArrowUpIcon}
            ></Button>
            <Button
              onClick={() => handleDown(item.id)}
              icon={ArrowDownIcon}
            ></Button>
            <Button icon={EditIcon} onClick={() => handleEdit(item.id)}>
              Edit
            </Button>
          </ButtonGroup>,
        ])
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Title", value: "title" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }

  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };

  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`brands/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const [activeShow, setActiveShow] = useState(false);
  const handleChangeModalShow = useCallback((activeShow) => {
    setActiveShow(!activeShow);
  }, []);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <Page
      title="Goal Subtasks"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem}>
          Add Subtask
        </Button>
      }
      backAction={{ onAction: () => navigate(`/admin/goals/${id}`) }}
      fullWidth
    >
      <FormLayout>
        <Card padding="0">
          {loadingMarkup}

          <Filters
            queryValue={queryValue}
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />

          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Task
              </Text>,

              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={items}
            sortable={[false, false, false, false]}
            defaultSortDirection="descending"
            initialSortColumnIndex={0}
            onSort={handleSort}
            verticalAlign="middle"
            stickyHeader
            // hasZebraStripingOnData
            footerContent={
              items?.length &&
              `Showing ${items.length} of ${totalPages} results`
            }
            increasedTableDensity
          />

          {emtyState}
        </Card>
        {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <MyPagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
      </FormLayout>
      <Modal
        // size="small"
        open={activeShow}
        onClose={handleChangeModalShow}
        title={result?.[currentIndex]?.business_name ?? ""}
        primaryAction={{
          content: "Next",
          onAction: handleNext,
          disabled: currentIndex === result?.length - 1,
        }}
        secondaryActions={[
          {
            content: "Previous",
            onAction: handlePrevious,
            disabled: currentIndex === 0,
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            {result?.[currentIndex]?.website ? (
              <FormLayout>
                <Link
                  monochrome
                  onClick={() =>
                    window.open(result?.[currentIndex]?.website, "_blank")
                  }
                >
                  {result?.[currentIndex]?.website}
                </Link>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}

            {result?.[currentIndex]?.ios || result?.[currentIndex]?.android ? (
              <FormLayout>
                <Text as="p" fontWeight="semibold">
                  Mobile apps:
                </Text>
                <div
                  className="divCursor"
                  style={{ display: "flex", gap: "8px" }}
                >
                  {result?.[currentIndex]?.ios && (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(result?.[currentIndex]?.ios, "_blank")
                      }
                    >
                      <Tag>iOS</Tag>
                    </div>
                  )}
                  {result?.[currentIndex]?.android && (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(result?.[currentIndex]?.android, "_blank")
                      }
                    >
                      <Tag>Android</Tag>
                    </div>
                  )}
                </div>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}
            {result?.[currentIndex]?.location ? (
              <FormLayout>
                <Text as="p" fontWeight="semibold">
                  Location
                </Text>
                <Text>{result?.[currentIndex]?.location}</Text>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}
            {result?.[currentIndex]?.type !== null ? (
              <FormLayout>
                <Text as="p" fontWeight="semibold">
                  Type
                </Text>
                <Text>
                  {String(result?.[currentIndex]?.type) === "1"
                    ? "Direct"
                    : "Indirect"}
                </Text>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}
            {result?.[currentIndex]?.location ? (
              <FormLayout>
                <Text as="p" fontWeight="semibold">
                  Description
                </Text>
                <Text>{result?.[currentIndex]?.description}</Text>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}
            {result?.[currentIndex]?.location ? (
              <FormLayout>
                <Text as="p" fontWeight="semibold">
                  Why Considered Task
                </Text>
                <Text>{result?.[currentIndex]?.why_is_task}</Text>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}
            {result?.[currentIndex]?.screenshots?.length ? (
              <FormLayout>
                <Text as="p" fontWeight="semibold">
                  Screenshots
                </Text>
                <div style={{ display: "flex", gap: "10px" }}>
                  {result?.[currentIndex]?.screenshots.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`image-${index}`}
                      style={{
                        width: "100px", // fixed width
                        height: "100px", // fixed height
                        objectFit: "cover", // maintain aspect ratio, crop if necessary
                        cursor: "pointer", // optional if you want them clickable
                      }}
                      onClick={() => console.log(`Clicked image ${index}`)}
                    />
                  ))}
                </div>
                <Divider borderColor="border" />
              </FormLayout>
            ) : null}

            {/* <Box>
              <Pagination
                hasPrevious={currentIndex > 0}
                onPrevious={handlePrevious}
                hasNext={currentIndex < result?.length - 1}
                onNext={handleNext}
              />
            </Box> */}
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Brand"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this brand?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default Tasks;
